import BadDarkIcon from "@/assets/icons/latency/bad_dark.svg";
import BadLightIcon from "@/assets/icons/latency/bad_light.svg";
import BestDarkIcon from "@/assets/icons/latency/best_dark.svg";
import BestLightIcon from "@/assets/icons/latency/best_light.svg";
import GoodDarkIcon from "@/assets/icons/latency/good_dark.svg";
import GoodLightIcon from "@/assets/icons/latency/good_light.svg";
import MediumDarkIcon from "@/assets/icons/latency/medium_dark.svg";
import MediumLightIcon from "@/assets/icons/latency/medium_light.svg";

const OffDarkIcon =
    '<svg width="24" height="9" viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="2" height="5" fill="white"/><rect x="6" y="2" width="3" height="5" fill="white"/><rect x="11" y="2" width="4" height="5" fill="white"/><rect x="17" y="2" width="5" height="5" fill="white"/></svg>';

const OffLightIcon =
    '<svg width="24" height="9" viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="2" height="5" fill="#595959"/><rect x="6" y="2" width="3" height="5" fill="#595959"/><rect x="11" y="2" width="4" height="5" fill="#595959"/><rect x="17" y="2" width="5" height="5" fill="#595959"/></svg>';

export const latencyIcons = {
    light: {
        best: BestLightIcon,
        good: GoodLightIcon,
        medium: MediumLightIcon,
        bad: BadLightIcon,
        off: OffLightIcon,
    },

    dark: {
        best: BestDarkIcon,
        good: GoodDarkIcon,
        medium: MediumDarkIcon,
        bad: BadDarkIcon,
        off: OffDarkIcon,
    },
};
